import {StreamTarget, StreamTargetType} from "./streamTargetDTO";
import {Box, Button, Chip, TableCell, TableRow, Typography} from "@mui/material";
import {Delete} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {removeStreamTarget} from "./streamTargetActions";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import classNames from "classnames";
import {withStyles} from "@mui/styles";
import styles from "./StreamTargetAccount-jss";
import {streamTargetService} from "../../services/stream-target";

type Properties = {
    classes: any,
    streamTarget: StreamTarget,
    removeStreamTarget: Function
};

function StreamTargetAccount(props: Properties) {
    const {
        classes,
        streamTarget,
        removeStreamTarget,
    } = props;

    const {t} = useTranslation();

    function handleDelete() {
        removeStreamTarget(streamTarget);
    }

    function getIconForTarget(targetName: string) {
        const Icon = streamTargetService.getIconForTarget(targetName);
        return <Icon fontSize="small" />;
    }

    function renderScheduledAccountSummary() {
        const accounts = streamTarget.schedule?.accounts || [];
        if (streamTarget.type !== StreamTargetType.SCHEDULED_LIVE || accounts.length === 0) {
            return null;
        }

        return (
            <Box mt={0.5} display="flex" flexWrap="wrap" alignItems="center" gap={0.75}>
                <Chip size="small" color="secondary" label={t("Scheduled")} />
                {accounts.map((account) => {
                    const Icon = streamTargetService.getIconForTarget(account.type);

                    return (
                        <Box key={account.uuid} display="inline-flex" alignItems="center" gap={0.5}>
                            <Icon fontSize="small" />
                            <Typography variant="caption" color="text.secondary">
                                {account.name}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        );
    }

    return (
        <TableRow key={ streamTarget.key }>
            <TableCell className={classNames(classes.tableCellIcon)}>{getIconForTarget(streamTarget.type)}</TableCell>
            <TableCell className={classNames(classes.tableCellKey)}>
                <Box>
                    <Typography variant="body2">{streamTarget.title}</Typography>
                    {renderScheduledAccountSummary()}
                </Box>
            </TableCell>
            <TableCell className={classNames(classes.tableCellDelete)}>
                <Button color="inherit" aria-label={t('Delete')} onClick={ handleDelete } startIcon={<Delete />}>
                    {t('Delete')}
                </Button>
            </TableCell>
        </TableRow>
    );
}

const mapDispatchToProps = function (dispatch: Dispatch) {
    return {
        removeStreamTarget: (streamTarget: StreamTarget) => dispatch(removeStreamTarget(streamTarget)),
    }
}

export default withStyles(styles)(connect(null, mapDispatchToProps)(StreamTargetAccount));
